<template>
  <div>
    <HeaderGuest v-if="!isAuthorize || (authInfo.email == emailPublic && pathHome)" />
    <Header v-else-if="isAuthorize" />
    <main role="main" id="main_app">
      <slot />
    </main>
    <Footer />
    <!-- <FooterNew /> -->
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import HeaderGuest from '@/components/HeaderGuest'
import Header from '@/components/Header'
import { EMAIL_PUBLIC, PASS_PUBLIC } from '@/store/auth/constants'
import Footer from '@/components/Footer'
import FooterNew from '@/components/FooterNew'
import JWT from "@/utils/jwt"

export default {
  components: {
    HeaderGuest,
    Header,
    Footer,
    FooterNew
  },
  data() {
    return {      
      isAuthorize: JWT.getAccessToken(),
      pathHome:true,
      authInfo: {},
      emailPublic: EMAIL_PUBLIC
    }
  },
  mounted(){
    this.authInfo = JWT.getAuth()
    if(!this.authInfo){
      this.loginFast()
    }
    if(this.$router.currentRoute.path == '/'){

      this.pathHome = true
    }
    else{
      this.pathHome = false
    }
  },
  methods:{
    ...mapActions(`auth`, [
      "authLogin",
      "authRegister",
      "authLoginFacebook",
      "authLoginGoogle",
      "authLogout"
    ]),
    loginFast(routerTo = 'NOTREDIRECT') {
				var postData={
					username: EMAIL_PUBLIC,
					password: PASS_PUBLIC,
					router_to: routerTo,
          callbackFunction: ()=>{
            this.authInfo = JWT.getAuth()
          }
				}
				this.authLogin(postData);
       
			},
  }
}
</script>
<style lang="scss" scoped>
#main_app {
    min-height: calc(100vh - 204px);
}
</style>